import { Inject, Injectable } from '@angular/core';
import { ObjectHash } from '../object-hash/object-hash.service';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable()
export class ImCachedObject {
  constructor(
    @Inject('CachedObject') private cachedObject,
    private objectHash: ObjectHash,
    private utilitiesService: UtilitiesService,
  ) {}

  createFromObject(obj) {
    obj = this.utilitiesService.toPOJO(obj);
    const hash = this.objectHash.createHash(obj);
    return new this.cachedObject({
      _id: hash,
      json: JSON.stringify(obj),
    });
  }
}
